<template>
  <!-- 拒绝 -->
  <el-dialog :append-to-body="true" :visible.sync="value" :title="title" center :show-close="false" width="480px" custom-class="approve-edit-con" :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed">
    <a class="close-con" @click="refuseDialogClosed">
      <i class="iconfont iconshanchu"></i>
    </a>
    <h1 class="title-desc">{{titleDesc}}</h1>
    <div class="modify-con">
      <div class="item item-refuse-con">
        <span class="label">{{label}}：</span>
        <div class="lebel-con">
          <el-input :placeholder="`请输入${label}，${maxLength}字以内`" type="textarea" :rows="5" :show-word-limit="true" :maxlength="maxLength" v-model="remark" />
        </div>
      </div>
      <div class="item custom-btn menu-list menu-refuse-list">
        <el-button type="primary" @click="refuseEvent">提交</el-button>
        <el-button type="info" @click="refuseDialogClosed">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ApproveRefuseModal',
  props: {
    value: Boolean,
    label: {
      type: String,
      default: '拒绝原因'
    },
    title: {
      type: String,
      default: '审批操作'
    },
    maxLength: {
      type: Number,
      default: 150
    },
    titleDesc: String
  },
  data () {
    return {
      remark: ''
    }
  },
  methods: {
    refuseDialogClosed () {
      this.remark = '';
      this.$emit('input', false);
    },
    refuseEvent () {
      this.$emit('confirm', this.remark);
    },
    closed () {
      this.remark = '';
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/approve.less');
</style>
<style scoped lang="less">
.item-refuse-con{
  -webkit-box-align: start !important;
  .label{
    min-width: 80px !important;
    margin-top: 10px !important;
  }
}
.menu-refuse-list{
  padding-left: 80px !important;
}
.title-desc{
  text-align: center;
  margin-top: -5px;
  color: #000;
  font-size: 12px;
}
</style>